import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AgendaService } from '../../../../../core/services/agenda.service';
import { UsefulInformationService } from '../../../../../core/services/useful-information.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-agenda',
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        LoadingComponent,
        SampleSearchPipe,
        HeaderComponent,
        NgSelectModule,
        NgxPaginationModule,
        AngularEditorModule
    ],
    templateUrl: './agenda.component.html',
    styleUrls: ['./agenda.component.css']
})
export class AgendaComponent {
  buttonsPermission :any|undefined;
  search_text=""
   ays:any[] =[]
   periods:any[] =[]
   roles:any[] =[]
   data:any[] =[]
   categories:any[] =[]
   cibles:any[] =[]
   selected_data:any;
   modalOption:any; 
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="admin-agendas"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
   fileInput:any

 
   constructor(
     private agendaService:AgendaService,
     private toastrService:ToastrService,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
    this.cibles=this.lsService.get(GlobalName.features).information_types
     this.init()
      this.getActions()
   }
 
   init(){
     this.getAll()
   }
 
  


   getAll(){
    this.agendaService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion de l'agenda ",err)
    })
  }
 
 
   store(value:any){

     var d1 = new Date(value.meet_datetime)
     var d2 = new Date()
     if(d1 < d2){
      this.toastrService.error("Vous ne pouvez pas programmer un rendez vous sur une date passée.")
      return ;
     } 



     let formData= new FormData()
     for (const key in value) {
       if (Object.prototype.hasOwnProperty.call(value, key)) {
         const element = value[key];
         formData.append(key,element)
       }
     }
 
     if (this.fileInput!=undefined) {
         formData.append("filename",this.fileInput)
     }
          this.loading=true

     this.agendaService.store(value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion de l'agenda ",err)
 
     })
   }
   update(value:any){
    var d1 = new Date(value.meet_datetime)
    var d2 = new Date()
    if(d1 < d2){
     this.toastrService.error("Vous ne pouvez pas programmer un rendez vous sur une date passée.")
     return ;
    } 

     this.loading=true
 
     this.agendaService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion de l'agenda ",err)
 
     })
   }
   delete(){
     if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.agendaService.delete(this.selected_data.id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion de l'agenda ",err)
 
     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.is_active
   }
   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalOption={centered:false,size:"lg"}
     this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }

   upload(ev:any){
    if (ev?.target.files.length!=0) {
      this.fileInput=ev?.target.files[0]
    }
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.agendaService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion de l'agenda ",err)
 
       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }

   
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:true,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }
}
